var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfDocumentsIna(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#73889C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.682 20.941H11.54a.796.796 0 0 0-.825.796c0 .456.37.825.825.825h12.143a.825.825 0 0 0 .796-.825.796.796 0 0 0-.796-.796zM11.539 17.345h12.143a.825.825 0 0 0 0-1.62H11.54a.825.825 0 1 0 0 1.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.032 2.844c-.63-.64-1.49-1-2.388-1.002h-8.99A5.158 5.158 0 0 0 5.527 7v20.808a5.158 5.158 0 0 0 5.129 5.158h13.882a5.187 5.187 0 0 0 5.158-5.158V11.893a3.39 3.39 0 0 0-1.002-2.417l-6.661-6.632zM21 4.112l6.425 6.425h-4.627A1.827 1.827 0 0 1 21 8.739V4.112zm7.074 23.696a3.537 3.537 0 0 1-3.537 3.537H10.655a3.537 3.537 0 0 1-3.537-3.537V7a3.537 3.537 0 0 1 3.537-3.537h8.724V8.74a3.39 3.39 0 0 0 3.419 3.39h5.276v15.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.682 26.128H11.54a.825.825 0 0 0-.825.826.796.796 0 0 0 .825.795h12.143c.44 0 .796-.356.796-.795a.825.825 0 0 0-.796-.826z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfDocumentsIna);
export default __webpack_public_path__ + "static/media/af-documents-ina.d5d61aa420538de3d603030511e02481.svg";
export { ForwardRef as ReactComponent };